export function selectStory(reduxStore) {
  return reduxStore.oneStory.allStories;
}
